import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import Button from '@eversports/klimt-primitives/legacy/Button'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Processing from '@eversports/klimt-primitives/legacy/Processing'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import AcceptFriendIcon from '../../../../../../assets/icons/accept-friend.svg'
import { useApproveFriendRequestButtonAcceptFriendRequestMutation } from '../../../../../../graphql'
import { Localized } from '../../../../../../localization/react'
import DeclineFriendRequest from '../../../Friends/MyFriends/RequestsList/ReceivedFriendRequest/DeclineFriendRequest'

interface Props {
  publicUserId?: string
}

const ApproveFriendRequestButton = ({ publicUserId }: Props) => {
  const { amplitude } = useAmplitude()
  const [approveFriendRequest, { loading }] = useApproveFriendRequestButtonAcceptFriendRequestMutation({
    variables: { userId: publicUserId! },
  })

  const handleClick = () => {
    if (amplitude) {
      amplitude.logEvent('Clicked Approve Received Friend Request Button')
    }
    void approveFriendRequest()
  }

  return (
    <Stack direction="row" alignItems="center" flexShrink={0} gap={2}>
      <Processing isLoading={loading}>
        <Button
          variant="secondary"
          sx={{ textTransform: 'none', paddingY: { xs: 3, md: 2 }, paddingX: 6, width: 'fit-content' }}
          onClick={handleClick}
        >
          <Stack alignItems="center" direction="row" gap={2}>
            <Icon size="small" color="primary" src={AcceptFriendIcon} />
            <Text sx={{ color: 'primary.main', fontWeight: 'bold' }}>
              <Localized id="approve-friend-request-button-text" />
            </Text>
          </Stack>
        </Button>
      </Processing>
      <DeclineFriendRequest friendId={publicUserId!} />
    </Stack>
  )
}

export default ApproveFriendRequestButton
